// [background, text] per club, for the little team chips on /live and in the
// admin Booth tab's game monitor. Keyed by MLB Stats API abbreviation.
export const TEAM = {
  ARI: ["#A71930", "#E3D4AD"],
  ATH: ["#003831", "#EFB21E"],
  OAK: ["#003831", "#EFB21E"],
  ATL: ["#13274F", "#FFFFFF"],
  BAL: ["#DF4601", "#000000"],
  BOS: ["#BD3039", "#FFFFFF"],
  CHC: ["#0E3386", "#FFFFFF"],
  CWS: ["#27251F", "#C4CED4"],
  CIN: ["#C6011F", "#FFFFFF"],
  CLE: ["#00385D", "#FFFFFF"],
  COL: ["#333366", "#C4CED4"],
  DET: ["#0C2340", "#FA4616"],
  HOU: ["#002D62", "#EB6E1F"],
  KC: ["#004687", "#BD9B60"],
  LAA: ["#BA0021", "#FFFFFF"],
  LAD: ["#005A9C", "#FFFFFF"],
  MIA: ["#00A3E0", "#0B1A2A"],
  MIL: ["#12284B", "#FFC52F"],
  MIN: ["#002B5C", "#FFFFFF"],
  NYM: ["#002D72", "#FF5910"],
  NYY: ["#0C2340", "#FFFFFF"],
  PHI: ["#E81828", "#FFFFFF"],
  PIT: ["#27251F", "#FDB827"],
  SD: ["#2F241D", "#FFC425"],
  SF: ["#FD5A1E", "#27251F"],
  SEA: ["#0C2C56", "#FFFFFF"],
  STL: ["#C41E3A", "#FFFFFF"],
  TB: ["#092C5C", "#8FBCE6"],
  TEX: ["#003278", "#FFFFFF"],
  TOR: ["#134A8E", "#FFFFFF"],
  WSH: ["#AB0003", "#FFFFFF"],
};
